module.exports = __webpack_public_path__ + "static/media/Network_Workspace_School_Import_Template.b6959159.xlsx";